<template>
  <v-dialog v-model="dialog" persistent max-width="600">
    <app-snackbar
      :text = "snackBarText"
      :show.sync = "snackbarNotification"
      :color = "snackbarColor"
      :timeOut = "timeOut"
    ></app-snackbar>
    <template v-slot:activator="{ on }">
    <div class="form-accept">
      <v-btn
        v-on="on"
        @click="$emit('update:snackbar', false);"
        fixed
        large
        dark
        fab
        bottom
        color="#0099E1"
      >
        <v-icon x-large>check</v-icon>
      </v-btn>
    </div>
    </template>
    <v-card>
      <v-card-title>
        <h2>Equipo</h2>
      </v-card-title>
      <v-card-text>
        <v-form v-model="validInput">
          <v-container>
            <v-layout column>
              <v-select label="Tipo de equipo*"
                v-model="type"
                :items="allDeviceTypes"
                item-text="label"
                item-value="id"
                color="0099E1"
                :rules="requiredRule"
              ></v-select>
              <v-text-field label="Nombre de equipo*"
                v-model="name"
                color="0099E1"
                :rules="requiredRule"
              ></v-text-field>
              <v-text-field label="Nombre del lote*"
                v-model="lotName"
                color="0099E1"
                :rules="requiredRule"
              ></v-text-field>
              <v-text-field label="Largo del equipo [m]*"
                v-model="equipmentLength"
                color="0099E1"
                type="number"
                :rules="requiredRule"
              ></v-text-field>
              <v-text-field label="Caudal [m3/h]*"
                v-model="pumpFlow"
                color="0099E1"
                type="number"
                :rules="requiredRule"
              ></v-text-field>
              <v-text-field label="Superficie (has)*"
                v-model="equipmentArea"
                color="0099E1"
                type="number"
                :rules="requiredRule"
              ></v-text-field>
              <v-select
                v-model="cropTypes"
                :items="allCropTypes"
                item-text="label"
                item-value="id"
                label="Cultivos"
                color="0099E1"
                multiple
              ></v-select>
            </v-layout>
          </v-container>
        </v-form>
        <small>*datos requeridos</small>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="onCancel()">Cancelar</v-btn>
        <v-btn color="primary" text @click="onSave()" :disabled="disableCreation">Registrar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
  import {
    CREATE_DEVICE_MUTATION,
    UPDATE_DEVICE_ORGANIZATION_MUTATION,
    ALL_CROP_TYPES_QUERY,
    ALL_DEVICE_TYPES_QUERY
  } from '../../../constants/graphql.js';
  import _orderBy from 'lodash/orderBy';

  export default {
    data () {
      return {
        allDeviceTypes: [],
        name: '',
        type: '',
        equipmentArea: '',
        disableCreation: false,
        cropTypes: [],
        lotName: '',
        pumpFlow: '',
        equipmentLength: '',
        allCropTypes: [],
        dialog: false,
        validInput: '',
        requiredRule: [v => !!v || 'El campo es requerido'],
        snackbarNotification: false,
        snackBarText: '',
        snackbarColor: '',
        timeOut: 5000
      };
    },
    apollo: {
      allDeviceTypes: {
        query: ALL_DEVICE_TYPES_QUERY
      },
      allCropTypes: {
        query: ALL_CROP_TYPES_QUERY,
        result ({data}) {
          this.allCropTypes = _orderBy(data.allCropTypes, ['label']);
        }
      }
    },
    props: {
      location: Object,
      snackbar: Boolean,
      orgId: Number
    },
    computed: {
      showOrgId () {
        return this.orgId;
      }
    },
    methods: {
      onCancel () {
        this.$emit('update:snackbar', true);
        this.dialog = false;
      },
      onSave () {
        if (this.validInput) {
          this.disableCreation = true;
          const cropTypesIds = [];
          this.cropTypes.forEach(id => {
            cropTypesIds.push({
              id
            });
          });
          const data = {
            name: this.name,
            pumpFlow: parseFloat(this.pumpFlow),
            length: parseInt(this.equipmentLength),
            area: parseFloat(this.equipmentArea),
            deviceTypeId: this.type,
            orgId: this.orgId,
            crop: this.lotName,
            cropTypesIds,
            latitude: this.location.lat,
            longitude: this.location.lng
          };
          this.$apollo.mutate({
            mutation: CREATE_DEVICE_MUTATION,
            variables: data
          }).then((result) => {
            this.$apollo.mutate({
              mutation: UPDATE_DEVICE_ORGANIZATION_MUTATION,
              variables: {
                orgId: this.orgId,
                deviceId: result.data.createDevice.id
              }
            }).then(() => {
              this.$router.push({name: 'UserInfo', params: { deviceCreated: true }});
            }).catch((error) => {
              console.log(error);
            });
          }).catch((error) => {
            console.log(error);
          });
        } else {
          this.snackbarNotification = true;
          this.snackBarText = 'Debes completar los campos requeridos *';
          this.snackbarColor = 'red';
        }
      }
    }
  };
</script>



// WEBPACK FOOTER //
// DeviceCreationForm.vue?1e58c420